import { useContext, useEffect, useState } from "react";
import {
  WeeklyTopSearch,
  WeeklyTopSearchProduct
} from "../../../models/home-rows";
import { _c } from "../../../services/text-services";
import SearchDialog from "./search-dialog/search-dialog.component";
import SearchForm from "./search-form/search-form.component";
// @ts-ignore 
import { useRouter } from "next/router";
import { RootCategoryModel } from "../../../models/root-category.model";
import { SearchResponse } from "../../../models/search-response";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { useLocalStorage } from "../../../services/local-storage-services";
import { ROUTES } from "../../../services/router-services";
import { filterProductType } from "../../../services/product-service";
import FetchData from "../fetch-data/fetch-data";
import styles from "./search.component.module.scss";
interface AppSearchProps {
  isMobile?: boolean;
  isMenu?: boolean;
}
function AppSearch({ isMobile, isMenu }: AppSearchProps) {
  const showResult = false;
  const router = useRouter();
  const appCtx = useContext(AppContext);
  const { isLoggedIn } = appCtx;
  const [selectedCat, setSelectedCat] = useState<number>(0);
  // const [listOfKeyword, setListOfKeyword] = useState<string[]>([]);
  const [defaultProducts, setDefaultProducts] =
    useState<WeeklyTopSearchProduct[]>();
  const [categories, setCategories] = useState<RootCategoryModel[]>([]);
  const { showFixedSearch, setShowFixedSearch, recentSearch, setRecentSearch } =
    appCtx;
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResult, setSearchResult] = useState<SearchResponse>({
    products: []
  });
  const [isLoading, setIsLoading] = useState(false);
  const [counter, setCounter] = useState(0);
  const { storedValue: localKeyword, setValue: setLocalKeyword } =
  useLocalStorage("keyword", "");
  const isAcceptableQuery = (query: string) => query.length > 2;

  useEffect(() => {
    showFixedSearch && setShowSearchDialog(false);
  }, [showFixedSearch]);

  // useEffect(() => {
  //   if (isAcceptableQuery(query)) {
  //     setIsLoading(true);
  //     const timeout = setTimeout(() => {
  //       // setSearchResult(products.slice(0, 6));
  //       setIsLoading(false);
  //     }, 3000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [query]);

  const saveKey = (keyword: string) => {
    let keywords = localKeyword ? JSON.parse(localKeyword) : [];
    keywords.push(keyword);
    keywords = Array.from(new Set(keywords));
    setLocalKeyword(JSON.stringify(keywords));
  } 

  useEffect(() => {
    if (isLoggedIn)
      !appCtx.recentlyUserSearch?.products
        ? API.fetchAuth({
            url: API.request_recently_user_search,
            token: appCtx.token,
            requestInfo: { method: "GET" }
          }).then(res => {
            res.json().then((input) => {
              const data = input as WeeklyTopSearch;
              const filterProducts = data.products.filter( item => filterProductType(item.product_type))
              setDefaultProducts(filterProducts);
              appCtx.setRecentlyUserSearch({categories: data.categories , products: filterProducts});
            });
          })
        : setDefaultProducts(appCtx.recentlyUserSearch.products);
    else {
      //console.log("appCtx.weeklyTopSearch", !appCtx.weeklyTopSearch);

      !appCtx.weeklyTopSearch?.products
        ? API.fetchJson(API.request_weekly_top_search).then(
            (input) => {
              const data = input as WeeklyTopSearch;
              const filterProducts = data.products.filter( item => filterProductType(item.product_type))
              setDefaultProducts(filterProducts);
              data && appCtx.setWeeklyTopSearch({categories: data.categories , products: filterProducts});
            }
          )
        : setDefaultProducts(appCtx.weeklyTopSearch.products);
    }
    (appCtx.rootCategories && appCtx.rootCategories.length === 0)
      ? API.fetchJson<RootCategoryModel[]>(API.request_category(0)).then(
          (categories) => {
            let accessibleCategories : RootCategoryModel[] = [];
            categories?.forEach(category => {
              if (category.is_visible && category.is_enable)
                accessibleCategories.push(category);
            });
            setCategories(accessibleCategories);
            appCtx.setRootCategories(accessibleCategories);
          }
        )
      : setCategories(appCtx.rootCategories);
  }, []);

  return (
    <>
      {query && (
        <FetchData
          url={API.request_search_tag}
          method="POST"
          pendingHandlerSetter={loadingState => setIsLoading(loadingState)}
          counter={counter}
          body={JSON.stringify({
            category: selectedCat,
            limit: 7,
            tag: query
          })}
          onSuccessful={data => {
            //console.log("got resp: ", data );
            const searchResult = {products: (data as SearchResponse).products.filter(item => filterProductType(item.product_type) )}
            setSearchResult(searchResult);
            saveKey(query);
          }}
          unAuthorized={!isLoggedIn}
          with_dg_id
        />
      )}
      <div className={_c(styles, isMenu ? "fixed" : "wrapp")}>
        {/* <!-- Desktop input form --> */}
        <SearchForm
          setQuery={query => {
            setQuery(query);
            setCounter(c => c + 1);
          }}
          onEnterKeyPressed={() => {
            router.push(ROUTES.search(selectedCat, query))
            setShowFixedSearch(false);
          }}
          onEscapeKeyPressed={() => {
            setShowSearchDialog(false);
            setQuery("");
          }}
          onFocus={() => !isMenu && setShowSearchDialog(true)}
          isMenu={isMenu}
          isMobile={isMobile}
        />
        {/* <!-- Search Dialog --> */}
        {(isMenu || showSearchDialog) && (
          <SearchDialog
            query={query}
            isLoading={isLoading}
            isLogin={isLoggedIn}
            categories={categories}
            searchResult={searchResult.products}
            defaultProducts={defaultProducts?.slice(0, 6) || []}
            onCloseButton={() => {
              //console.log("close-clicked");
              //console.log("isMenu: ", isMenu);
              //console.log("showSearchDialog: ", showSearchDialog);
              setQuery("");
              setShowSearchDialog(false);
              setShowFixedSearch(false);
              // setCounter(c => c + 1);
            }}
            isMenu={isMenu}
            isMobile={isMobile}
            onSearchedKey={(key) => {
              setQuery(key);
              setCounter(c => c + 1)
            }}
            onSeeAllResults={() => {
              //console.log("got on the top query: ", query);
              router.push(ROUTES.search(selectedCat, query))
              setShowFixedSearch(false);
            }}
            searchInRootCategory={catId => {
            setSelectedCat(catId), setCounter(c => c + 1);
            }}
          />
        )}
      </div>
    </>
  );
}

export default AppSearch;
